angular.module('app').config(versioningRouting);

function versioningRouting($routeProvider) {
  $routeProvider.when('/versioning', {
    pageTitle: 'APP_VERSIONS',
    template: '<versioning-page></versioning-page>',
    accessPermission: 'index_versioning_superadmin',
    authReq: true,
  });
}

versioningRouting.$inject = ['$routeProvider'];
